const forms = {
  onRequest: "Sur demande", // translated
  person: "personne", // translated
  travelDate: "Date de voyage", // translated
  cancel: "Annuler", // translated
  getPrice: "Obtenir le prix", // translated
  travelDates: "Dates de voyage", // translated
};

export default forms;
